import { MantineColor, Stack, StyleProp, Text } from "@mantine/core"

import { CountryFlag } from "../../atoms/CountryFlag/CountryFlag"
import { CountryIso3166 } from "../Inputs/CountrySelector/CountriesSelector.types"
import { CountryMapper } from "../Inputs/CountrySelector/CountrySelector"

interface Props {
  countryIso3166: CountryIso3166
  countriesMapper: CountryMapper
  width?: number
  color?: StyleProp<MantineColor>
  inline?: boolean
}

export const CountryLabel = ({
  countryIso3166,
  countriesMapper,
  width,
  color,
  inline = false,
  ...rest
}: Props) => {
  if (!countriesMapper[countryIso3166]) {
    return null
  }
  return (
    <Stack
      gap={3}
      style={{
        flexDirection: inline ? "row" : "column",
        wrap: inline ? "nowrap" : "wrap",
      }}
      align={inline ? "center" : "flex-start"}
      {...rest}
    >
      <CountryFlag countryIso3166={countryIso3166} width={width} />
      <Text c={color}>{countriesMapper[countryIso3166].countryName}</Text>
    </Stack>
  )
}
